<template>
    <div class="main">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,index) in msg" :key="index">
                    <img :src="item.img" />
                    <div class="stitle">
                        <div class="animated animate__animated animate__fadeInLeft">
                            <h1>重庆佳渝测绘有限公司</h1>
                            <p>CHONGQING JIAYU SURVEYING AND MAPPING CQ.LTD</p>
                        </div>
                    </div>
                    <div class="estitle">
                        <div class="animated animate__animated animate__lightSpeedInLeft animate__delay-1s">
                            <p>主营业务:</p><span>不动产测绘、航空摄影、地理信息系统</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
        <!-- <el-divider></el-divider> -->
        <!-- product s -->
        <div class="product">
            <div class="page">
                <h3>主营业务</h3>
                <p>Main Business</p>
            </div>
            <div class="product-content" >
                <ul class="" ref="scrollfour">
                    <li>
                        <div class="product-content-img">
                            <img src="../assets/img/move1.png" alt="">
                        </div>
                        <div class="product-content-text">
                            <h5>不动产测绘</h5> 
                            <p>公司具有乙级测绘资质（乙测资质5010735），具有较为雄厚的技术力量和先进仪器设备。配备了GPS卫星定位系统、高精度进口全站仪、手持测距仪、绘图仪、扫描仪及成图软件等仪器设备。主要承接的工程项目有：基坑监测、建筑物沉降监测、控制测量、地形测量、城乡用地测量、市政工程测量、线路工程测量、桥梁测量、隧道测量、土石方面积测量、竣工测量等各类工程测量，地籍测绘、房产测绘等。</p>  
                        </div>

                    </li>
                    <li>
                        <div class="product-content-img">
                            <img src="../assets/img/move4.png" alt="">
                        </div>
                        <div class="product-content-text">
                            <h5>航空摄影</h5> 
                            <p>无人机可通过相机、激光雷达等控制设备来进行测量，并且可以预设航线，在作业区域上空自动作业采集数据，采集完数据后可导入本公司自主研发的系统，一键生成点云及三维模型数据，并据此进行空间距离、体积的测量，或者进行斜面等不规则堆体面积的模拟测量，为工程建设规划和生产作业等提供精确数值参考。人工测绘作业，不仅效率低、难度大、危险系数高，而且检测精细度远远不够，而无人机技术的应用，将在很大程度上解决了这一难题。</p>  
                        </div>

                    </li>
                </ul>
                <ul class="p2" ref="scrollfif">
                    <li>
                        <div class="product-content-img">
                            <img src="../assets/img/move6.png" alt="">
                        </div>
                        <div class="product-content-text">
                            <h5>地理信息系统</h5> 
                            <p>公司自主研发的地理信息管理系统软件，将无人机测量和传统测绘相结合，建立完善数据库，是行业内少有的数据整合系统。我司将此软件功能进行了延伸，研发出了“重庆市园区建设管理系统”和“重庆市土地巡查看护系统”，这将给客户带来便捷与高效。</p>  
                            <img src="../assets/img/cass8.jpg" alt="">
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <!-- cass s -->
         <div class="cass">
             <div class="bg" >
                <div class="page">
                    <h3>经典案例</h3>
                    <p>Suecessful Cass</p>
                </div>
                <ul class="case-item" ref="scrollOne">
                    <li 
                    v-for="(item,index) in caseList"
                    :key="index"
                    >
                        <img :src="item.imgurl" alt="">
                            <router-link
                                class="text-decoration"
                                :to="{ name: 'casedetails', params: { id: item.Id ,item}}"
                                >
                                <div class="case-item-hover">
                                    <p class="hover-title">{{item.title}}</p>
                                    <div class="bottom"></div>
                                    <div class="more">
                                    <span>MORE</span>
                                    </div>
                                </div>
                            </router-link>
                    </li>
                </ul>
             </div>
         </div>
        <!-- <el-divider></el-divider> -->
         <!-- cass e -->
         <!-- news s -->
        <div class="news">
                <div class="page">
                    <h3>最新资讯</h3>
                    <p>Latest News</p>
                </div>
                <div class="news-content" ref="scrollTwo">
                    <div class="news-content-item" v-for="(news,i) in newsList" :key="i">
                        <div :style="'order: '+ (i%2==0 ? 1: 3)">
                        <router-link
                            class="text-decoration"
                            :to="{ name: 'newsdetails', params: { id: news.Id,news }}"
                        >
                            <div class="item-img">
                                <img :src="news.imgurl" alt="">
                            </div>
                        </router-link>
                        </div>
                        <div style="order: 2">
                        <el-divider>
                            <i class="el-icon-apple"></i>
                        </el-divider>
                        </div>
                        <div class="item-content" :style="'order: '+ (i%2==0 ? 3: 1)">
                        <h3>{{news.title}}</h3>
                        <p>{{news.Content}}</p>
                        <span>{{news.CreateTime}}</span>
                        </div>
                    </div>
                </div>
        </div>
        <!-- <el-divider></el-divider> -->
        <!-- news e -->
        <!-- show s -->
        <div class="show">
            <div class="page">
                <h3>动态展示</h3>
                <p>Dynamic Show</p>
            </div>
            <div class="show-content" ref="threeHeight">
                <ul>
                    <li v-for="(show,idx) in showList" :key="idx">
                        <img :src="show.imgurl" :alt="show.intro">
                        <p><a :href="show.href">{{show.intro}}</a></p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import Swiper from 'swiper'//引入swiper三方模块


export default {
    data(){
        return{
            msg:[
                {
                    img:require('../assets/img/banner1.png')
                },
                // {
                //     img:require('../assets/img/img8.jpg')
                // },
            ],
            caseList:[
                {
                    Id:1,
                    title:"沙坪坝区迈瑞城投健康城项目",
                    CreateTime:"沙坪坝区迈瑞城投健康城项目无人机航摄正射影像生产成果",
                    Content:"该项目是我公司受重庆迈瑞城投有限公司委托，对沙坪坝区健康城项目进行无人机航摄，制作高精度影像图。影像分辨率为5公分，1:500比例尺。利用高精度影像对项目区的土地利用现状、建筑情况进行摸底调查。",
                    imgurl:require('../assets/img/cass1.jpg')
                },
                {
                    Id:2,
                    title:"云阳-石缸景区1:2000地形测量",
                    CreateTime:"云阳-石缸景区1:2000地形测量",
                    Content:" 外业采用油动固定翼搭载索尼A7R2（35mm）进行航片采集，结合RTK制作地面相控。内业采用密集点云、DOM、DEM数字高程模型进行高程点采集和地物绘制。多数据模型结合制作而成。",
                    imgurl:require('../assets/img/cass2.jpg')
                },
                {
                    Id:3,
                    title:"沙坪坝区博物馆三维重建",
                    CreateTime:"沙坪坝区博物馆三维重建",
                    Content:"沙坪坝区博物馆为古代中式风格建筑物。博物馆占地面积约1500平方米。我们采用小精灵进行五条航带飞行数据采集。利用ContextCapture 软件即可制作三维实景模型。同时也可发布到网络共享。",
                    imgurl:require('../assets/img/cass3.jpg')
                },
                {
                    Id:4,
                    title:"沙坪坝融汇温泉城三维重建",
                    CreateTime:"沙坪坝融汇温泉城三维重建",
                    Content:"该模型为城市重建区，涉及高层建筑、坡地等复杂区。采用大疆M600 Pro搭载睿铂Riy-D2五镜头，飞行高度300米，2架次完成1.4平方公里三维建模。在模型中可对土石方等工程建设方量进行测算。",
                    imgurl:require('../assets/img/cass4.jpg')
                },
                {
                    Id:5,
                    title:"渝北区统大路1:500地形测量",
                    CreateTime:"渝北区统大路1:500地形测量",
                    Content:"该项目受渝北区交委委托，对统景镇到大盛镇沿线10公里进行道路及两侧300米地形测量。采用多旋翼无人机进行带状飞行测量。采用RTK在地面制作像控点，保证了测量精度。使用3Dsurvey 进行植被滤波处理，减小了因植被造成的高程误差。",
                    imgurl:require('../assets/img/cass5.jpg')
                },
                {
                    Id:6,
                    title:"地理信息系统",
                    CreateTime:"",
                    Content:"",
                    imgurl:require('../assets/img/cass6.jpg')
                },

            ],
            newsList:[
                {
                    Id:1,
                    Type:1,
                    title:"不动产测绘的现状及问题分析",
                    CreateTime:"2019-11-30 15:42:38",
                    Content:`现状及问题分析:一是相关法规有待完善。目前，我国不动产测绘方面的法律主要包括《测绘法》 《房产测绘管理办法》等。伴随着不动产测绘工作的逐步深入，相关法律监管内容也有所改进，监管范围也有所扩大。但非常遗憾的是，不动产测绘的相关规定都较为粗线条，如《城市房地产管理法》《城市房地产开发经营管理条例》等的内容中，均只大致提到房产测绘工作，并未对房产测绘做出具体的要求。而其他类型的不动产测绘，面临的情况也大致相同。二是缺乏强有力的监管。目前，测绘机构入市门槛非常低，通常只需要10万元注册资金与3名技术人员便可申请入市。在此背景下，测绘机构多良莠不齐，大部分业务水平不高，不能满足市场需求。如：随着我国房产测绘行业的快速发展，房产测绘业务的规模与技术难度均明显提高，远超出了这些低资质房测机构的承受范围。由于技术落后、设备不足、人员技术水平不高等原因而导致测绘数据质量低劣。此外，在经济利益的驱使下，有房产测绘机构违背测绘规定或者打擦边球，以满足房地产开发企业的不合理要求。这直接扰乱了房地产市场的正常秩序，也使得购房人的合法权益受到损害。此外，现有的测绘成果异议处理机制中，由省级测管部门设立测绘成果质量监督检验机构，主要负责对测绘成果的监督检验，并具有委托检验与司法仲裁检验的职能。然而，在实践中因为很多主客观原因，该机构无法对不动产测绘成果进行有效的异议处理。三是测绘效率有待提高。目前，不动产测绘涉及多个部门，由于尚无统一标准，标准规范繁多，各部门在不动产测绘工作中往往各自为政，其所遵循的规范、标准及数据库规范方面均存在明显的不一致，最终造成房产、地籍等各类数据分离生产，相互不关联。比如，在土地数据中不能查到没有坐标的房产分层分户数据。同时，也不能将房产图形与档案相联系。这些情况的存在，造成不动产数据存在很大的安全隐患。所载内容来源互联网，微信公众号等公开渠道，转载的稿件版权归原作者和机构所有，如有侵权，请联系我们删除。`,
                    imgurl:require('../assets/img/new10.jpg')
                },
                {
                    Id:8,
                    Type:1,
                    title:"航空摄影的分类和操作实施",
                    CreateTime:"2019-9-28 15:59:12",
                    Content:` 航空摄影又称“空中摄影”。是指利用航空器上安置专用航空摄影仪，从空中对地面或空中目标所进行的摄影方式。按摄影目标和方向的不同，可划分为垂直摄影、倾斜摄影和对空摄影。能减少野外作业量，减轻劳动强度，并且不受地理环境条件的限制，具有快速、精确、经济等优点。广泛用于测绘地图、地质、水文、矿藏和森林资源调査、农业产量评估及大型厂矿和城镇的规划、铁路、公路、高压输电线路和输油管线的勘察选线、气象预报和环境监测等,也可用于航空侦察、新闻报道和拍摄电影、电视片。
                                航空摄影一般选在上午或下午，因为上午或下午地面上的景物比较清晰，有足够的照度，容易收到较好的影调效果。 航空摄影始于19世纪50年代，纳达尔是首位实现航拍的摄影师和气球驾驶者，他于1858年在法国巴黎上空拍摄。当时从气球上用摄影机拍摄的城市照片，虽只有观赏价值，却开创了从空中观察地球的历史。1909年美国的莱特(W.Wright)第一次从飞机上对地面拍摄像片。此后，随着飞机和飞行技术，以及摄影机和感光材料等的飞速发展,航空摄影像片的质量有了很大提高,用途日益广泛。它不仅大量用于地图测绘方面，而且在国民经济建设、军事和科学研究等许多领域中得到广泛应用。
                                基本分类:根据用途的不同，航空摄影可选用不同的方式和感光材料，从而得到功能不同的航空像片。按像片倾斜角分类,按像片倾斜角分类（像片倾斜角是航空摄影机主光轴与通过透镜中心的地面铅垂线（主垂线）间的夹角），可分为垂直摄影和倾斜摄影。
                                倾斜角等于0°的，是垂直摄影，这时主光轴垂直于地面（与主垂线重合），感光胶片与地面平行。但由于飞行中的各种原因，倾斜角不可能绝对等于0°，一般凡倾斜角小于3°的称垂直摄影。由垂直摄影获得的像片称为水平像片。水平像片上地物的影像，一般与地面物体顶部的形状基本相似，像片各部分的比例尺大致相同。水平像片能够用来判断各目标的位置关系和量测距离。倾斜角大于3°的，称为倾斜摄影，所获得的像片称为倾斜像片。这种像片可单独使用，也可以与水平像片配合使用。
                                按摄影的实施方式分类:按摄影的实施方式分类，可分为单片摄影、航线摄影和面积摄影。单片摄影：为拍摄单独固定目标而进行的摄影称为单片摄影，一般只摄取一张（或一对）像片。航线摄影：沿一条航线，对地面狭长地区或沿线状地物（铁路、公路等）进行的连续摄影，称为航线摄影。为了使相邻像片的地物能互相衔接以及满足立体观察的需要，相邻像片间需要有一定的重叠，称为航向重叠。航向重叠一般应达到60%，至少不小于53%。
                                面积摄影：沿数条航线对较大区域进行连续摄影，称为面积摄影（或区域摄影）。面积摄影要求各航线互相平行。在同一条航线上相邻像片间的航向重叠为60—53%。相邻航线间的像片也要有一定的重叠，这种重叠称为旁向重叠，一般应为30—15%。实施面积摄影时，通常要求航线与纬线平行，即按东西方向飞行。但有时也按照设计航线飞行。由于在飞行中难免出现一定的偏差，故需要限制航线长度。一般为60—120km，以保证不偏航，而产生漏摄。
                                按感光材料分类:可分为全色黑白摄影、黑白红外摄影、彩色摄影、彩色红外摄影和多光谱摄影等。全色黑白摄影：采用全色黑白感光材料进行的摄影。它对可见光波段（0.4—0.76μm）内的各种色光都能感光，是一种应用范围广，容易收集到的航空遥感材料。如我国为测制国家基本地形图摄制的航空像片即属此类。
                                黑白红外摄影：采用黑白红外感光材料进行的摄影。它能对可见光、近红外光（0.4—1.3μm）波段感光，尤其对水体植被反应灵敏，所摄像片具有较高的反差和分辨率。
                                彩色摄影：彩色像片虽然也是感受可见光波段内的各种色光，但由于它能将物体的自然色彩、明暗度以及深浅表现出来，因此与全色黑白像片相比，影像更为清晰，分辨能力高。
                                彩色红外摄影：彩色红外摄影虽然也是感受可见光和近红外波段（0.4—1.3μm），但却使绿光感光之后变为蓝色，红光感光之后变为绿色，近红外感光后成为红色，这种彩色红外片与彩色片相比，在色别、明暗度和饱合度上都有很大的不同。例如在彩色片上绿色植物呈绿色，在彩色红外片上却呈红色。由于红外线的波长比可见光的波长长，受大气分子的散射影响小，穿透力强，因此，其彩色红外片色彩要鲜艳得多。
                                多光谱摄影：多光谱摄影是利用摄影镜头与滤光片的组合，同时对一地区进行不同波段的摄影，取得不同的分波段像片。例如通常采用的四波段摄影，可同时得到蓝、绿、红及近红外波段四张不同的黑白像片，或合成为彩色像片；或将绿、红、近红外三个波段的黑白像片，合成假彩色像片。`,
                    imgurl:require('../assets/img/new18.jpg')
                },
                {
                    Id:3,
                    Type:1,
                    title:"影响无人机成果精度三大要素",
                    CreateTime:"2018-10-19 13:39:59",
                    Content:`一、无人机航空摄影测量概述:低空数字航空摄影测量相对传统摄影测量来说，机动快速，操作简单，云下摄影，能获取高分辨率航空影像，影像制作周期短，效率高，成本低，在应急测绘、困难地区测绘、小城镇测绘、重大工程项目测绘、小范围高精度测绘应用广泛。 
                            但是，固定翼无人机舰空摄影侧量系统采用的传感器是由工业级CCD 改装的相机。这种相机为非测量相机，较之传统的测绘航空摄影传惑器，存在着光学畸变差CCD阵面非正交性所产生的误差。另外，由于CCD阵面为非正方形，其摄影机的放置方式也影响实际航空摄影的基线长度。再加上后期像控点联测，立体量测的误差，形成了影像无人机航空摄影测量最终产品质量的主要因素。
                            二、影响无人机航测精度的几大要素:固定翼无人机航空测量系统在进行地形测量时，存在着测量误差。这些误差主要来源于仪器误差、人为误差、气候等外界因素影响产生的误差。a、仪器误差:由于仪器设计、制作不完善，或经校验还存在残余误差。这部分误差主要是传感器量化过程带来的系统误差。由于固定翼无人机的载重及体积的原因，无法搭载常规的航摄仪进行测绘航空摄影，自前选用的是中幅面CCD作为传感器的感光单元，经过加固和电路改装以后，成为具有稳定内方价元索豹数码相机。由于感光单元的非正方形因子和非正交性以及畸变差的存在，畸变差的存在使测量成果无法满足精度要求。
                            小型数码相机一般均为矩形阵面的CCD，并非传统的正方形。像片重叠度越大基线越短，基高比越小，正常情况下，其基高比为0.15左右，远小于传统摄影的0.50，在立体模型下，同名地物交会角较小，降低了立体观测效果，直接影响高程量测精度。如果在保证具有三度重叠的前提下，尽量减少相片重叠度或使CCD阵面的长边与摄影航线相一致，可以大大增加基高比，提高高程量测精度
                            b、人为误差:由于人的感官鉴别能力、技术水平和工作态度因素带来的误差，以及像控识别、空三加密、立体采集产生的人为误差。像控点精度有刺点精度和观测精度。在观测精度符合设计要求的情况下，刺点精度成为影响像片控制测量精度的主要因素。由于固定翼无人机的像幅较小，可供选择像控点位的范围相对较小，经常会出现在像控点布设的范围内找不到明显地物刺点，尤其是在野外居民地稀少地区，像控点选刺在地物棱角是否明显，影像反差是否理想的地点，都是制约像控点精度的因素。 
                            外业像控点测量时，对目标点的选取主要取决于影像纹理的丰富程度，影像纹理粗糙、弧形地物、线状地物交角不好，直接影响了外业点位选取精度，同时内业对像控点的转刺同样有较大的误差，较低了成图精度。如果采取先布设地面目标点后摄影，则能较大提高外业选点精度和内业转刺点精度，有助于提高成图质量。 内业数据采集分为空三加密与立体量测。像控点识别与判读均会与外业实际位置产生一定的误差，空三加密时也会有一定的误差，还有在立体采集量测时切测的误差等等。c、外界因素:由于天气状况对飞行器姿态和成像质量的影响产生的误差。对摄影成像来说，景物亮度的大小只影响像片上的曝光量，重要的是像片上相邻地物影像之间的密度差，如果地物影像之间没有密度差异，也就是没有影像反差，也就无法从影像上辨别地物，而决定影像反差的因素除了景物本身特征外，主要取决于阳光部分和阴影部分照度之间的差异，如果选择天气条件不好时摄影，必然使影像质量变差。 
                            微型无人机体积较小，一般都在三十公斤之内，在摄影时受气流、风力、风向影响较大，无法保持直线平稳飞行，航线倾角、旁向倾角和旋转角都很大，飞行姿态难以控制，飞机在航线前后左右等方向上摆动造成了影像模糊，影像了清晰度。另外，由于遥控无人机采用低空飞行，航高较低，相对地面物体移动速度较快，在曝光过程中，成像面上的地物构像随之产生位移，形成像移，像移的出现同样使影像模糊，影响了成像质量。`,
                    imgurl:require('../assets/img/new11.jpg')
                },
            ],
            showList:[
                {
                    imgurl:require('../assets/img/show1.jpg'),
                    intro:"重庆佳渝测绘公司全景图",
                    href:"https://720yun.com/t/c72judukeO5?scene_id=21769553"
                },
                {
                    imgurl:require('../assets/img/show2.jpg'),
                    intro:"沙坪坝组团B分区B12/02号地块",
                    href:"https://720yun.com/t/779rye6en50od4azua?pano_id=vW2qQIz6jPZ7E0RE"
                },
                {
                    imgurl:require('../assets/img/show3.jpg'),
                    intro:"大学城熙街2期",
                    href:"https://720yun.com/t/b71jOpeO5k7?scene_id=2583170"
                },
                {
                    imgurl:require('../assets/img/show4.jpg'),
                    intro:"日本河口湖--720°VR全景漫游",
                    href:"https://720yun.com/t/0a2jvssfkn9?scene_id=19921066"
                }
            ]
        }    
    },
    methods: {
        swiperFn(){
            new Swiper('.swiper-container', {
                
                pagination: {
                    el: '.swiper-pagination'
                },
                autoplay: true
            })
        },
        handleScroll() {
        //获取滚动时的高度
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            let oneHeight = this.$refs.scrollOne;
            let twoHeight = this.$refs.scrollTwo;
            let threeHeight=this.$refs.threeHeight
            let fourHeight=this.$refs.scrollfour
            let fifHeight=this.$refs.scrollfif
            console.log(scrollTop)
            if (scrollTop >400) {
                fourHeight.className=' animated animate__animated animate__fadeInLeft'
            }
            if (scrollTop >500) {
                fifHeight.className='p2 animated animate__animated animate__fadeInRight'
            }
            if (scrollTop >1700) {
                oneHeight.className='case-item animated animate__animated animate__fadeInLeft'
            }
            if (scrollTop > 2200) {
                twoHeight.className='news-content animated animate__animated animate__fadeInTopLeft'
            }
            if (scrollTop > 2700) {
                threeHeight.className='show-content animated animate__animated animate__rollIn'
            }
        }
    },
    mounted() {
        this.swiperFn(),
        window.addEventListener("scroll",this.handleScroll); 
    },
    destroyed() {
      document.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style  lang="scss" scoped>
.main {
    width:100%;
    margin:0 auto;
    overflow: hidden;
img{
    width: 100%;
    height: 100%;
}
}
.swiper-container{
    width: 100%;
    .swiper-slide{
        position: relative;
        .stitle{
            width: 60%;
            position: absolute;
            top: 25%;
            left: 5%;
            color: #fff;
            font-size: 46px;
            border-bottom: 1px solid #FFF;
            h1{
                letter-spacing:15px;
                line-height: 50px;
            }
            P{
                font-size: 16px;
                line-height: 55px;
                letter-spacing:9px;
            }
        }
        .estitle{
            position: absolute;
            top: 60%;
            left: 25%;
            color: #fff;
            p{
                display: inline;
                font-size: 35px;
            }
            span{
                font-size: 30px;
                letter-spacing: 5px;
                margin-left: 10px;
            }
        }
    }
}
.animate__animated.animate__lightSpeedInLeft {
  --animate-duration: 4s;
}
.bg{
    width: 100%;
    height: 100%;
    // background:url('../assets/img/bg1.jpg')no-repeat center ;
    overflow: hidden;
    background-color: #fff;
}
.page {
    text-align: center;
    height: 100%;
    overflow: hidden;
    margin: 80px 0;
    h3,p {
      font-size: 40px;
      font-weight: 400;
    //   color: #fff;
    }
}
//经典案例
.case-item {
  width: 80%;
  height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 80px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  li {
    width: 30%;
    height: 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;
    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(124, 121, 121, 0.7);

  .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
    text-align: center;
  }
  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }
  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;
    color:#fff;
    text-align: center;
    span {
    //   color: #fff;
      font-size: 20px;
    }
  }
}
//最新资讯
.news{
    width: 100%;
    height: 100%;
    // background: url(../assets/img/bg2.jpg) no-repeat center;
    background-size: cover;
    overflow: hidden;
    background-color: #fff;
    padding-bottom: 90px;
}
.news-content {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap:wrap;
  &-item {
    width: 400px;
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    .item-img {
      width: 360px;
      height: 230px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }
    .el-divider {
    //   background-color: #fff;
      height: 3px;
      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        // color: #fff;
      }
    }
    .item-content {
      width: 360px;
      height: 230px;
      margin: 0 auto;
      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p {
        color:gray;    
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
        text-indent: 35px;
      }
      span {
        display: block;
        font-size: 14px;
        text-align: end;
        color:gray;
      }
    //   h3,
    //   p,
    //   span {
    //     // color: #fff;
    //   }
    }
  }
}
.order {
  order: -1;
}
.order-img {
  order: 1;
}
//动态展示
.show{
    width: 100%;
    height: 100%;
    // background: url(../assets/img/bg2.jpg) no-repeat center;
    overflow: hidden;
    background-color: #fff;
}
.show-content{
    width: 90%;
    margin: 0 auto;
    display: flex;
    ul{
        margin: 0 auto;
        margin-bottom: 180px;
        display: flex;
        justify-content: center;
        li{
            width: 30%;
            margin: 0 30px;
            img{
                width: 100%;
                height: 100%;
            }
            p{
                text-align: center;
                font-size: 18px;
                font-weight: bolder;
                padding: 20px 0;
                a{
                    color: gray;
                }
                &:hover{
                    background-color: #1469;
                    cursor: pointer;
                    a{
                        color: #fff;
                    }
                }
            }
        }
    }
}
.product{
    width: 100%;
    height: 100%;
    // background: url(../assets/img/bg2.jpg) no-repeat center;
    background-size: cover;
    overflow: hidden;
    background-color: #fff;
    padding-bottom: 90px;
}
.product-content{
    width: 90%;
    margin: 0 auto;
    // background-color: yellowgreen;
    ul{
        width: 100%;
        display: flex;
        justify-content: space-around;
        li{
            display: flex;
            justify-content: center;
            width: 40%;
            margin-left: 20px;
            .product-content-img{
                width: 50%;
            }
            .product-content-text{
                width: 50%;
                line-height: 40px;
                margin-left: 20px;
                :nth-child(2){
                    font-size: 14px;
                    text-indent: 30px;
                    margin-top: 20px;
                    color: gray;
                }
                h5{
                    font-size: 22px;
                    line-height: 60px;
                    border-bottom: 1px solid #000;
                }
            }
        }
    }
    .p2{
        width: 100%;
        display: flex;
        justify-content: space-around;
        margin-top: 30px;
        li{
            display: flex;
            justify-content:space-around;
            align-items: center;
            width: 90%;
            margin-left: 20px;
            .product-content-img{
                width: 50%;
            }
            .product-content-text{
                width: 50%;
                line-height: 30px;
                margin-left: 20px;
                :nth-child(2){
                    font-size: 14px;
                    text-indent: 30px;
                    margin-top: 30px;
                    color: gray;
                }
                 h5{
                    font-size: 22px;
                    line-height: 60px;
                    border-bottom: 1px solid #000;
                }
                img{
                    width: 70%;
                    margin: 0 130px;
                }
            }
        }
    }
}
@import url('~swiper/css/swiper.min.css');
</style>